import { type TFunction } from 'i18next';

import {
  type AuthConfigDTO,
  IdValidationConfigPreset,
  OrganizationUpdateRequestDTOTalentUniqueFieldsItem
} from '@/api/generated';

import { ID_STRUCTURE_OPTIONS } from './types';

export const getIdFieldsOptions = (t: TFunction) => [
  {
    label: t('orgSettings.options.idFields.idNumber'),
    value: OrganizationUpdateRequestDTOTalentUniqueFieldsItem.ID_NUMBER
  },
  {
    label: t('orgSettings.options.idFields.passportNumber'),
    value: OrganizationUpdateRequestDTOTalentUniqueFieldsItem.PASSPORT_NUMBER
  },
  {
    label: t('orgSettings.options.idFields.phone'),
    value: OrganizationUpdateRequestDTOTalentUniqueFieldsItem.PHONE
  },
  {
    label: t('orgSettings.options.idFields.email'),
    value: OrganizationUpdateRequestDTOTalentUniqueFieldsItem.EMAIL
  }
];

export const getValidationTypesOptions = (t: TFunction) => [
  {
    label: t('orgSettings.options.validationTypes.none'),
    value: IdValidationConfigPreset.NONE
  },
  {
    label: t('orgSettings.options.validationTypes.israel'),
    value: IdValidationConfigPreset.ISRAEL
  },
  {
    label: t('orgSettings.options.validationTypes.mexico'),
    value: IdValidationConfigPreset.MEXICO
  },
  {
    label: t('orgSettings.options.validationTypes.custom'),
    value: IdValidationConfigPreset.CUSTOM
  }
];

export const getIdStructureOptions = (t: TFunction) => [
  {
    label: t('orgSettings.options.idStructure.letters'),
    value: ID_STRUCTURE_OPTIONS.LETTERS
  },
  {
    label: t('orgSettings.options.idStructure.numbers'),
    value: ID_STRUCTURE_OPTIONS.NUMBERS
  },
  {
    label: t('orgSettings.options.idStructure.both'),
    value: ID_STRUCTURE_OPTIONS.BOTH
  }
];

type AuthConfigKey = keyof Omit<AuthConfigDTO, 'invalidateAfterDays'>;

export const MFAConfigKeys = {
  PASSKEY: 'passkey' as AuthConfigKey,
  CALL: 'call' as AuthConfigKey,
  WHATSAPP: 'whatsapp' as AuthConfigKey,
  SMS: 'sms' as AuthConfigKey,
  APP: 'app' as AuthConfigKey
};
